module.exports = __webpack_public_path__ + "img/ppt.e70b594e.png";